import { makeAutoObservable } from "mobx";

export default class HistoricalBaselineData {
  period;
  periodWeight;
  historicalPlannedCost;
  historicalPlannedProgress;
  historicalActualCost;
  historicalActualProgress;
  historicalEarnedValue;
  historicalEarnedSchedule;
  historicalSPI_T;
  historicalSPI_C;
  historicalBAC;
  historicalFAC_Mean;
  historicalCPI;
  historicalNote;

  constructor(
    period,
    periodWeight,
    historicalPlannedCost,
    historicalPlannedProgress,
    historicalActualCost,
    historicalActualProgress,
    historicalEarnedValue,
    historicalEarnedSchedule,
    historicalSPI_T,
    historicalSPI_C,
    historicalBAC,
    historicalFAC_Mean,
    historicalCPI,
    historicalNote
  ) {
    this.period = period;
    this.periodWeight = periodWeight;
    this.historicalPlannedCost = historicalPlannedCost;
    this.historicalPlannedProgress = historicalPlannedProgress;
    this.historicalActualCost = historicalActualCost;
    this.historicalActualProgress = historicalActualProgress;
    this.historicalEarnedValue = historicalEarnedValue;
    this.historicalEarnedSchedule = historicalEarnedSchedule;
    this.historicalSPI_T = historicalSPI_T;
    this.historicalSPI_C = historicalSPI_C;
    this.historicalBAC = historicalBAC;
    this.historicalFAC_Mean = historicalFAC_Mean;
    this.historicalCPI = historicalCPI;
    this.historicalNote = historicalNote;

    makeAutoObservable(this);
  }

  toJS() {
    return {
      period: this.period,
      periodWeight: this.periodWeight,
      historicalPlannedCost: this.historicalPlannedCost,
      historicalPlannedProgress: this.historicalPlannedProgress,
      historicalActualCost: this.historicalActualCost,
      historicalActualProgress: this.historicalActualProgress,
      historicalEarnedValue: this.historicalEarnedValue,
      historicalEarnedSchedule: this.historicalEarnedSchedule,
      historicalSPI_T: this.historicalSPI_T,
      historicalSPI_C: this.historicalSPI_C,
      historicalBAC: this.historicalBAC,
      historicalFAC_Mean: this.historicalFAC_Mean,
      historicalCPI: this.historicalCPI,
      historicalNote: this.historicalNote,
    };
  }

  static fromJS(object) {
    const historicalBaseline = new HistoricalBaselineData();
    if (object !== null) {
      historicalBaseline.period = object.period;
      historicalBaseline.periodWeight = object.periodWeight;
      historicalBaseline.historicalPlannedCost = object.historicalPlannedCost;
      historicalBaseline.historicalPlannedProgress =
        object.historicalPlannedProgress;
      historicalBaseline.historicalActualCost = object.historicalActualCost;
      historicalBaseline.historicalActualProgress =
        object.historicalActualProgress;
      historicalBaseline.historicalEarnedValue = object.historicalEarnedValue;
      historicalBaseline.historicalEarnedSchedule =
        object.historicalEarnedSchedule;
      historicalBaseline.historicalSPI_T = object.historicalSPI_T;
      historicalBaseline.historicalSPI_C = object.historicalSPI_C;
      historicalBaseline.historicalBAC = object.historicalBAC;
      historicalBaseline.historicalFAC_Mean = object.historicalFAC_Mean;
      historicalBaseline.historicalCPI = object.historicalCPI;
      historicalBaseline.historicalNote = object.historicalNote;
    }
    return historicalBaseline;
  }
}


